export default __webpack_public_path__ + "static/media/digital-gift-card.inline.11f85f35.svg";